import Jsona from 'jsona';

export const strict = false;
export const type = 'host';

export const HOSTS = 'HOSTS';
export const SELECT = 'SELECT';
export const SELECTED = 'SELECTED';
export const GET = 'GET';
export const SET_HOSTS = 'SET_HOSTS';
const SET_SELECTED = 'SET_SELECTED';

export const state = () => ({
  data: [],
  selected: {}
});

export const actions = {
  async [SELECT]({ getters, state, commit }, {
    email, slug, eventTypeSlug, date, time, frontendRetry = 0
  }) {
    const response = await this.$axios.$get(
      'api/v1/appointments/select',
      {
        params: {
          email,
          slug,
          date,
          time,
          event_type_slug: eventTypeSlug,
          frontend_retry: frontendRetry
        }
      }
    );

    const data = new Jsona().deserialize(response);

    commit(SET_SELECTED, data);

    return data;
  },

  async [GET]({ getters, state, commit }, { email }) {
    const response = await this.$axios.$get(
      'api/v1/appointments/team_member', { params: { email } }
    );

    const data = new Jsona().deserialize(response);

    commit(SET_SELECTED, data[0]);

    return data[0];
  }
};

export const mutations = {
  [SET_HOSTS](state, users) {
    state.data = users;
  },
  [SET_SELECTED](state, user) {
    state.selected = user;
  }
};

export const getters = {
  [HOSTS](state, getters) {
    return state.data.map(user => ({ ...user, companyId: user.company.id }));
  },
  [SELECTED](state, getters) {
    return state.selected;
  }
};
